import { call, put, select, takeLatest, all, delay } from 'redux-saga/effects';
import Action from '../action';
import InvoiceApi from '../../Api/inoviceApi';
import date from '../../../../Utils/Date';
import Fomatter from '../../../../Utils/formatter';
import {
  setSnackBar,
  setDialog,
  getInvoice,
  getInvoiceTemp,
  getInvoicePos,
  getInvoiceList,
  getInvoicePosList,
  setInvoiceList,
  getInvoiceListTotalAmout,
  getInvoicePosListTotalAmout,
} from './Common';
import taker from './taker';
import Func from '../../../../Utils/func';
import { MENU_INFO } from '../../../../Utils/enums';

/**
 * [Inquiry] invoice 팝업 flag
 */
export function* isInvoiceDetailPopup({ payload }) {
  //조건 초기화
  if (payload) {
    yield put(Action.isInvoiceDetailPopup.success(payload));
  } else {
    yield put(Action.isInvoiceDetailPopup.success(payload));
    yield put(Action.getInvoice.success({ invoiceItemDtoList: [] }));
  }
}

/**
 * [Issue] invoice 복사 발급 invoice list
 * @param {*} param
 */
export function* getCopyIssueInvoiceList({ payload }) {
  const tin = payload.tin;
  const branchCode = payload.branchCode;
  const regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택하는 정규식

  if (payload?.uniqueInvoiceId) {
    payload.uniqueInvoiceId = payload.uniqueInvoiceId.replaceAll('-', '');
  } else {
    payload = {
      ...payload,
      tin: tin.replace(regex, ''),
      branchCode: branchCode.replace(regex, ''),
    };
  }

  yield call(getInvoiceList, payload);
}

/**
 * [Inquiry] invoice 상세정보
 */
export function* getInvoiceDetail({ payload }) {
  //inquiry / hold / poscrm 분기
  if (payload.type === 'inquiry') {
    payload = {
      ...payload,
      uniqueInvoiceId: payload.uniqueInvoiceId.replaceAll('-', ''),
    };
    yield call(getInvoice, payload);
  } else if (payload.type === 'hold') {
    yield call(getInvoiceTemp, payload);
  } else if (payload.type === 'poscrm') {
    payload = {
      ...payload,
      uniqueInvoiceId: payload.uniqueInvoiceId.replaceAll('-', ''),
    };
    yield call(getInvoicePos, payload);
  }

  yield put(Action.isInvoiceDetailPopup.success(true));
}

export function* getCopyCorrectionInvoiceDetail({ payload }) {
  payload = {
    ...payload,
    uniqueInvoiceId: payload.uniqueInvoiceId.replaceAll('-', ''),
  };
  // yield call(getInvoice, payload);
  let invoice;
  const response = yield call(InvoiceApi.getCopyCorrectionInvoiceDetail, {
    uniqueInvoiceId: payload.uniqueInvoiceId.replaceAll('-', ''),
  });

  if (response.status === 200) {
    invoice = response.data;
    yield put(Action.getInvoice.success(invoice));
  } else if (response.status === 203) {
    // 요청은 성공하였으나, 사용자 검증이 안됨
    Func.moveExUrl(MENU_INFO['issuance_2'].mainURL, null);
    window.location.reload();
  }
}

/**
 * [Inquiry] InquiryByCase 조회
 */
export function* getInvoiceInquiryByCase({ payload }) {
  const uniqueInvoiceId = payload.uniqueInvoiceId;

  payload = {
    ...payload,
    uniqueInvoiceId: uniqueInvoiceId.replaceAll('-', ''),
  };
  // yield call(setProgressBar, { payload: { open: true, message: '' } });
  let invoice;
  const response = yield call(InvoiceApi.getInvoice, payload);
  if (response.status === 200) {
    if (response.data.uniqueInvoiceId) {
      invoice = response.data;
      yield put(Action.isInvoiceSearchView.success(true));
      yield put(Action.getInvoice.success(invoice));
    } else {
      yield put(Action.isInvoiceSearchView.success(false));
      yield call(setSnackBar, {
        payload: {
          autoHideDuration: 5000,
          message: 'EIS Unique ID does not exist.',
          open: true,
          type: 'error',
        },
      });
    }
  } else if (response.status === 203) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Unauthorized EIS Unique ID ',
        closeLabel: 'confirm',
      },
    });
  }
}

/**
 * [Inquiry] InvoiceIssusanceList 조회
 */
export function* getInvoiceIssusanceList({ payload }) {
  const tin = payload.tin;
  const branchCode = payload.branchCode;
  const regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택하는 정규식

  //수정조회
  if (payload?.uniqueInvoiceId) {
    payload.uniqueInvoiceId = payload.uniqueInvoiceId.replaceAll('-', '');
  }

  payload = {
    ...payload,
    tin: tin.replace(regex, ''),
    branchCode: branchCode.replace(regex, ''),
  };

  //invoiceList 조회
  yield call(getInvoiceList, payload);
  //invoiceList TotalAmount 조회
  yield call(getInvoiceListTotalAmout, payload);
}

/**
 * [Inquiry] InvoiceTempList 조회
 */
export function* getInvoiceTempList({ payload }) {
  //TODO: 리팩토링
  let invoiceTempList;

  const buyerTin = payload.buyerTin;
  const buyerBranchCode = payload.buyerBranchCode;
  const regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택하는 정규식

  payload = {
    ...payload,
    buyerTin: buyerTin.replace(regex, ''),
    buyerBranchCode: buyerBranchCode.replace(regex, ''),
  };

  const response = yield call(InvoiceApi.getInvoiceTempList, payload);
  if (response.status === 200) {
    invoiceTempList = response.data;

    yield put(Action.setInvoiceList.success(invoiceTempList));
  }

  //대량발급 부분 분기처리
  if (!payload?.receptionNo) {
    let totalAmount;
    const response2 = yield call(
      InvoiceApi.getInvoiceTempListTotalAmount,
      payload
    );
    if (response2.status === 200) {
      totalAmount = response2.data;
      yield put(Action.setInvoiceListTotalAmount.success(totalAmount));
    }
  }
}

/**
 *
 * [Inquire] Hold issuance Delete InvoiceTemp LIST
 */
export function* deleteInvoiceTempList({ payload }) {
  let response;
  response = yield call(
    InvoiceApi.deleteInvoiceTempList,
    payload.invoiceTempNoList
  );
  if (response.status === 200) {
    if (payload.searchData) {
      yield call(getInvoiceTempList, { payload: payload.searchData });
    }
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Delete Success',
        closeLabel: 'confirm',
      },
    });
  } else {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Delete Fail',
        closeLabel: 'confirm',
      },
    });
  }
}

export function* getInvoiceCorrectList({ payload }) {
  let response;

  if (payload.type === 'inquiry') {
    response = yield call(InvoiceApi.getInvoiceList, payload);
  } else {
    response = yield call(InvoiceApi.getInvoicePosList, payload);
  }

  if (response.status === 200) {
    let invoiceList = response.data;

    // TODO: 2021/10/08 이부분 맞는지 확인필요
    yield put(Action.getInvoiceCorrectList.success(invoiceList));
  }
}

/**
 * [Inquiry POS/CRM]
 */
export function* getInvoicePosIssuanceList({ payload }) {
  // const sellerTin = payload.sellerTin;
  // const sellerBranchCode = payload.sellerBranchCode;
  // const regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택하는 정규식

  // payload = {
  //   ...payload,
  //   sellerTin: sellerTin.replace(regex, ""),
  //   sellerBranchCode: sellerBranchCode.replace(regex, ""),
  // };
  payload = {
    ...payload,
    uniqueInvoiceId: payload.uniqueInvoiceId.replaceAll('-', ''),
  };
  //invoiceList 조회
  yield call(getInvoicePosList, payload);

  //invoiceList TotalAmount 조회
  yield call(getInvoicePosListTotalAmout, payload);
}

/**
 * [Inquiry POS/CRM] InquiryByCase 조회
 */
export function* getInvoicePosInquiryByCase({ payload }) {
  payload = {
    ...payload,
    uniqueInvoiceId: payload.uniqueInvoiceId.replaceAll('-', ''),
  };

  let invoice;
  const response = yield call(InvoiceApi.getInvoicePos, payload);
  if (response.status === 200) {
    if (response.data.uniqueInvoiceId) {
      invoice = response.data;
      yield put(Action.isInvoiceSearchView.success(true));
      yield put(Action.getInvoice.success(invoice));
    } else {
      yield put(Action.isInvoiceSearchView.success(false));
      yield call(setSnackBar, {
        payload: {
          autoHideDuration: 5000,
          message: 'EIS Unique ID does not exist.',
          open: true,
          type: 'error',
        },
      });
    }
  } else if (response.status === 203) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Unauthorized EIS Unique ID',
        closeLabel: 'confirm',
      },
    });
  }
}
/**
 * [Issuance]  Issuance setInvocieList 조회 공통
 */
export function* setIssuanceInvoiceList({ payload }) {
  yield put(Action.setIssuanceInvoiceList.success(payload));
}

/**
 * [Inquiry] Inquiry Mail History 조회
 */
export function* getInvoiceEmailHistory({ payload }) {
  const buyerTin = payload.buyerTin;
  const buyerBranchCode = payload.buyerBranchCode;
  const regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택하는 정규식

  payload = {
    ...payload,
    buyerTin: buyerTin.replace(regex, ''),
    buyerBranchCode: buyerBranchCode.replace(regex, ''),
    uniqueInvoiceId: payload.uniqueInvoiceId.replaceAll('-', ''),
  };

  let response;
  response = yield call(InvoiceApi.getInvoiceEmailHistory, payload);

  if (response.status === 200) {
    let invoiceList = response.data;
    invoiceList.content.map((invoice) => {
      invoice.inEdit = true;
    });
    yield call(setInvoiceList, invoiceList);
  }
}

/**
 * [Inquiry] Inquiry Mail Resend 메일 재전송
 */
export function* postInvoiceEmailResend({ payload }) {
  let response;
  response = yield call(InvoiceApi.postInvoiceEmailResend, payload);

  if (response.status === 200) {
    yield call(setSnackBar, {
      payload: {
        message: 'Email successfully sent.',
        open: true,
        type: 'success',
      },
    });
  } else {
    yield call(setSnackBar, {
      payload: {
        message: 'Failed resend mail.',
        open: true,
        type: 'error',
      },
    });
  }
}

/**
 * [Inquiry] JWS Viewer 조회
 */
export function* getJWS({ payload }) {
  let response;
  const eisUniqueId = payload.eisUniqueId;
  const signature = payload.signature;

  if (
    payload.isPos &&
    eisUniqueId.substring(8, 10) != '31' &&
    eisUniqueId.substring(8, 10) != '32'
  ) {
    //Not POS,CRM Data
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Not POS/CRM JWS File',
        closeLabel: 'confirm',
      },
    });
    yield put(Action.initJWS.success());
  } else if (
    !payload.isPos &&
    (eisUniqueId.substring(8, 10) == '31' ||
      eisUniqueId.substring(8, 10) == '32')
  ) {
    //POS,CRM Data
    // yield call(setDialog, {
    //   payload: {
    //     open: true,
    //     message: 'POS/CRM JWS File',
    //     closeLabel: 'confirm',
    //   },
    response = yield call(InvoiceApi.getJWS, {
      eisUniqueId: eisUniqueId,
      signature: signature,
    });

    if (response.status === 200) {
      if (response.data) {
        yield put(Action.getJWS.success(payload.data));
      } else {
        yield put(Action.initJWS.success());
        yield call(setDialog, {
          payload: {
            open: true,
            message: 'Unregistered JWS',
            closeLabel: 'confirm',
          },
        });
      }
    } else {
      yield put(Action.initJWS.success());
      yield call(setDialog, {
        payload: {
          open: true,
          message: response.data.message,
          closeLabel: 'confirm',
        },
      });
    }

    // yield put(Action.initJWS.success());
  } else {
    response = yield call(InvoiceApi.getJWS, {
      eisUniqueId: eisUniqueId,
      signature: signature,
    });

    if (response.status === 200) {
      if (response.data) {
        yield put(Action.getJWS.success(payload.data));
      } else {
        yield put(Action.initJWS.success());
        yield call(setDialog, {
          payload: {
            open: true,
            message: 'Unregistered JWS',
            closeLabel: 'confirm',
          },
        });
      }
    } else {
      yield put(Action.initJWS.success());
      yield call(setDialog, {
        payload: {
          open: true,
          message: response.data.message,
          closeLabel: 'confirm',
        },
      });
    }
  }
}

export function* initJWS() {
  yield put(Action.initJWS.success());
}

export function* getVatMonthlyList({ payload }) {
  const response = yield call(InvoiceApi.getVatMonthlyList, payload);
  let monthlyList;
  if (response.status === 200) {
    monthlyList = response.data;
    yield put(Action.getVatMonthlyList.success(monthlyList));
  }
}

export function* getVatMonthlyDetail({ payload }) {
  const response = yield call(InvoiceApi.getVatMonthlyDetail, payload);
  let monthlyDetail;
  if (response.status === 200) {
    monthlyDetail = response.data;
    yield put(Action.getVatMonthlyDetail.success(monthlyDetail));
  } else if (response.status === 203) {
    // 요청은 성공하였으나, 사용자 뷸일치
    Func.moveExUrl(MENU_INFO['inquiry_3'].mainURL, null);
  }
}

export function* getVatQuarterlyList({ payload }) {
  const response = yield call(InvoiceApi.getVatQuarterlyList, payload);
  let quarterlyList;
  if (response.status === 200) {
    quarterlyList = response.data;
    yield put(Action.getVatQuarterlyList.success(quarterlyList));
  }
}

export function* getVatQuarterlyDetail({ payload }) {
  const response = yield call(InvoiceApi.getVatQuarterlyDetail, payload);
  let quarterlyDetail;
  if (response.status === 200) {
    quarterlyDetail = response.data;
    yield put(Action.getVatQuarterlyDetail.success(quarterlyDetail));
  } else if (response.status === 203) {
    // 요청은 성공하였으나, 사용자 뷸일치
    Func.moveExUrl(MENU_INFO['inquiry_4'].mainURL, null);
  }
}

export default [
  takeLatest(Action.getInvoice.TRIGGER, taker(getInvoice)),
  takeLatest(
    Action.getInvoiceInquiryByCase.TRIGGER,
    taker(getInvoiceInquiryByCase)
  ),
  takeLatest(Action.getInvoiceList.TRIGGER, taker(getInvoiceList)),
  takeLatest(Action.setInvoiceList.TRIGGER, taker(setInvoiceList)),
  takeLatest(
    Action.getInvoiceIssusanceList.TRIGGER,
    taker(getInvoiceIssusanceList)
  ),
  takeLatest(Action.getInvoiceDetail.TRIGGER, taker(getInvoiceDetail)),
  takeLatest(
    Action.getCopyCorrectionInvoiceDetail.TRIGGER,
    taker(getCopyCorrectionInvoiceDetail)
  ),
  takeLatest(Action.isInvoiceDetailPopup.TRIGGER, taker(isInvoiceDetailPopup)),
  takeLatest(
    Action.getCopyIssueInvoiceList.TRIGGER,
    taker(getCopyIssueInvoiceList)
  ),
  takeLatest(Action.getInvoiceTempList.TRIGGER, taker(getInvoiceTempList)),
  takeLatest(
    Action.deleteInvoiceTempList.TRIGGER,
    taker(deleteInvoiceTempList)
  ),
  takeLatest(
    Action.getInvoiceCorrectList.TRIGGER,
    taker(getInvoiceCorrectList)
  ),
  takeLatest(
    Action.setIssuanceInvoiceList.TRIGGER,
    taker(setIssuanceInvoiceList)
  ),
  takeLatest(
    Action.getInvoicePosIssuanceList.TRIGGER,
    taker(getInvoicePosIssuanceList)
  ),
  takeLatest(
    Action.getInvoicePosInquiryByCase.TRIGGER,
    taker(getInvoicePosInquiryByCase)
  ),
  takeLatest(
    Action.getInvoiceEmailHistory.TRIGGER,
    taker(getInvoiceEmailHistory)
  ),
  takeLatest(
    Action.postInvoiceEmailResend.TRIGGER,
    taker(postInvoiceEmailResend)
  ),
  takeLatest(Action.getJWS.TRIGGER, taker(getJWS)),
  takeLatest(Action.initJWS.TRIGGER, taker(initJWS)),

  takeLatest(Action.getVatMonthlyList.TRIGGER, taker(getVatMonthlyList)),
  takeLatest(Action.getVatMonthlyDetail.TRIGGER, taker(getVatMonthlyDetail)),
  takeLatest(Action.getVatQuarterlyList.TRIGGER, taker(getVatQuarterlyList)),
  takeLatest(
    Action.getVatQuarterlyDetail.TRIGGER,
    taker(getVatQuarterlyDetail)
  ),
];
